'use strict';

var _reactRouter = require('react-router');

/**
 * CANNOT use `import` to import `es5-shim`,
 * because `import` will be transformed to `Object.defineProperty` by babel,
 * `Object.defineProperty` doesn't exists in IE8,
 * (but will be polyfilled after `require('es5-shim')` executed).
 */

require('es5-shim');
require('es5-shim/es5-sham');
require('console-polyfill');
require('es6-promise');
require('fetch-ie8');

var createHashHistory = require('history/lib/createHashHistory');

/**
 * CANNOT use `import` to import `react` or `react-dom`,
 * because `import` will run `react` before `require('es5-shim')`.
 */
// import React from 'react';
// import ReactDOM from 'react-dom';

var React = require('react');
var ReactDOM = require('react-dom');
var App = require('./App');
var PrivacyPolicyCn = require('./PrivacyPolicyCn');
var PrivacyPolicyEn = require('./PrivacyPolicyEn');
var PrivacyPolicyTw = require('./PrivacyPolicyTw');
var PrivacyPolicyKo = require('./PrivacyPolicyKo');
var Eula = require('./Eula');
var Support = require('./Support');

var createComponent = function createComponent(Component, props) {
  return React.createElement(Component, props);
};

ReactDOM.render(React.createElement(
  _reactRouter.Router,
  { history: _reactRouter.browserHistory, createElement: createComponent },
  React.createElement(
    _reactRouter.Route,
    { path: '/' },
    React.createElement(_reactRouter.IndexRoute, { component: App }),
    React.createElement(_reactRouter.Route, { path: 'PrivacyPolicy', component: PrivacyPolicyCn }),
    React.createElement(_reactRouter.Route, { path: 'PrivacyPolicycn', component: PrivacyPolicyCn }),
    React.createElement(_reactRouter.Route, { path: 'privacypolicyen', component: PrivacyPolicyEn }),
    React.createElement(_reactRouter.Route, { path: 'privacypolicytw', component: PrivacyPolicyTw }),
    React.createElement(_reactRouter.Route, { path: 'privacypolicyko', component: PrivacyPolicyKo }),
    React.createElement(_reactRouter.Route, { path: 'eula', component: Eula }),
    React.createElement(_reactRouter.Route, { path: 'support', component: Support })
  )
), document.getElementById('app'));


//////////////////
// WEBPACK FOOTER
// ./entry.js
// module id = 0
// module chunks = 0